<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
      <form role="form" @submit.stop.prevent="validate().then(submitForm)">
        <div class="vx-row">
          <div class="vx-col mb-6">
            <span>Ativo</span>
            <vs-switch
              color="success"
              v-model="formData.isActive"
              style="width: 60px"
            >
              <span slot="on">Ativo</span>
              <span slot="off">Inativo</span>
            </vs-switch>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <ValidationProvider
              name="Nome"
              rules="required"
              v-slot="{ errors }"
            >
              <label class="label-text">Nome</label>
              <vs-input
                size="large"
                class="w-full"
                name="name"
                id="name"
                v-model="formData.name"
                :danger="!!errors.length"
              />
              <span v-show="!!errors.length" class="text-danger"
                >{{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <ValidationProvider
              name="Nome"
              rules="required"
              v-slot="{ errors }"
            >
              <label class="label-text">Chave Única</label>
              <vs-input
                size="large"
                class="w-full"
                name="Chave Única"
                id="Chave Única"
                v-model="formData.key"
                :danger="!!errors.length"
              />
              <span v-show="!!errors.length" class="text-danger"
                >{{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="warning"
              type="border"
              class="mr-3 mb-2"
              @click.stop.prevent="onReset"
              >Cancelar</vs-button
            >
            <BotaoSubmit
              variant="success"
              :edit="!!originSystem.id"
              :aguarde="isLoading"
              :disabled="invalid"
            ></BotaoSubmit>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import BotaoSubmit from '@/components/BotaoSubmit.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import originSystemApi from '@/services/origin.system.api';
import notify from '@/utils/notify';

export default {
  name: 'FormOriginSystem',
  components: {
    ValidationProvider,
    ValidationObserver,
    BotaoSubmit,
  },
  props: {
    originSystem: {
      type: Object,
      default: () => ({}),
    },
    sideBar: {
      type: Boolean,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: this.resetForm(),
      isLoading: false,
    };
  },
  methods: {
    async submitForm() {
      this.isLoading = true;
      if (this.originSystem.id) {
        await this.updateOriginSystemSystem();
      } else {
        await this.createOriginSystem();
      }
      this.isLoading = false;
    },
    updateOriginSystemSystem() {
      originSystemApi
        .updateOriginSystem(this.originSystem.id, this.formData)
        .then((data) => {
          notify.notifySuccess(
            this.$vs,
            'Origem da Cotação atualizada com sucesso!',
          );
          this.$emit('concluido', data);
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            notify.notifyFail(this.$vs, error.response.data.message);
          } else {
            notify.notifyFail(this.$vs, error);
          }
        });
    },
    createOriginSystem() {
      originSystemApi
        .createOriginSystem(this.formData)
        .then((data) => {
          notify.notifySuccess(
            this.$vs,
            'Origem da Cotação criada com sucesso!',
          );
          this.$emit('concluido', data);
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            notify.notifyFail(this.$vs, error.response.data.message);
          } else {
            notify.notifyFail(this.$vs, error);
          }
        });
    },
    resetForm() {
      return {
        isActive: true,
        name: '',
        key: '',
      };
    },
    fillForm() {
      if (this.originSystem && Object.keys(this.originSystem).length > 0) {
        this.formData = {
          id: this.originSystem.id,
          isActive: !this.originSystem.deletedAt,
          name: this.originSystem.name,
          key: this.originSystem.key,
        };
      } else {
        this.formData = this.resetForm();
      }
    },
    onReset(event) {
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
      if (this.sideBar === true) {
        this.$emit('cancel');
      } else {
        event.preventDefault();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  watch: {
    originSystem: {
      handler() {
        this.fillForm();
      },
    },
    active: {
      immediate: true,
      handler(newValue) {
        if (newValue === true) {
          this.fillForm();
        }
      },
    }
  },
};
</script>
